<template>
  <div class="my-10 break-word">
    <a v-if="link.url" :href="urlPath" class="bold underline-hover" target="_blank">{{ link.url }}</a>
  </div>
</template>
<script>
export default {
  name: "PostLink",
  props: {
    link: {},
  },
  computed: {
    urlPath: function () {
      let url = this.link.url.toLowerCase();
      if (!(url.includes("http://") || url.includes("https://"))) {
        url = "http://" + url;
      }
      return url.replace("http://bulletin.co", "https://bulletin.co");
    },
  },
};
</script>
